const { compareAsc, compareDesc, isValid } = require('date-fns');
const { isEmpty, getValidationDate, validateType } = require('../helpers/index');
const { dateSchema } = require('../schemas');

/**
 * validate fieldValue exists
 * @param {(String | date)} fieldValue
 * @param {object} validation
 * @param {*} validation.value if the field is mandatory
 * @param {string} validation.message message of error
 * @returns {(string | undefined)} `validation.message` or `undefined`
 */
const mandatory = (fieldValue, validation) => {
  const { value, message } = validation;
  return value && isEmpty(fieldValue) ? message : undefined;
};

/**
 *
 * @param {String} fieldValue date value in string format
 * @param {object} validation
 * @param {*} validation.value min value of a number
 * @param {string} validation.message message of error
 * @returns {(string | undefined)} `validation.message` or `undefined`
 */
const min = (fieldValue, validation) => {
  const { value, unit, message } = validation;
  if (isEmpty(fieldValue)) return undefined;
  try {
    const currentDate = new Date(fieldValue);
    const validDate = isValid(currentDate);
    const minDate = getValidationDate(value, unit, false);
    return validDate && compareDesc(minDate, currentDate) === -1 ? message : undefined;
  } catch (error) {
    return message;
  }
};

/**
 *
 * @param {String} fieldValue date value in string format
 * @param {object} validation
 * @param {*} validation.value max value of a number
 * @param {string} validation.message message of error
 * @returns {(string | undefined)} `validation.message` or `undefined`
 */
const max = (fieldValue, validation) => {
  const { value, unit, message } = validation;
  if (isEmpty(fieldValue)) return undefined;
  try {
    const currentDate = new Date(fieldValue);
    const validDate = isValid(currentDate);
    const maxDate = getValidationDate(value, unit, true);
    return validDate && compareAsc(maxDate, currentDate) === -1 ? message : undefined;
  } catch (error) {
    return message;
  }
};

const isValidType = (fieldValue, validation) => {
  if (fieldValue) {
    const { value, message } = validation;
    const currentValue = new Date(fieldValue);
    if (value && currentValue.toString() === 'Invalid Date') return message;
    const valid = validateType(currentValue, dateSchema);
    return value && !isEmpty(currentValue) && !valid ? message : undefined;
  }
  return undefined;
};

module.exports = {
  isValidType,
  mandatory,
  max,
  min,
};
